var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1026 2.94606C16.2121 1.04748 13.6935 0.00185926 11.0108 0.00185926H10.9992C5.59693 -0.108711 0.857489 4.64887 0.968716 10.0492C1.11013 13.8624 4.77855 18.7052 7.63529 22.4257C8.47425 23.4279 9.69667 24 11.0099 24C12.3692 23.9999 13.6313 23.3875 14.4724 22.3195C16.5917 19.686 21.1678 13.3518 21.0297 10.0491C21.0297 7.36439 19.9902 4.84184 18.1026 2.94606ZM12.9996 21.1594C12.0308 22.4373 9.9929 22.4396 9.02373 21.1616C5.1501 16.2292 2.84349 12.1215 2.84349 10.0491C2.84349 5.54286 6.50212 1.87678 10.9992 1.87678H11.0108C15.5015 1.87678 19.1549 5.5429 19.1549 10.0491C19.1549 12.144 16.9114 16.1935 12.9996 21.1594ZM11.0519 14.0164C8.85504 14.0164 7.06777 12.2291 7.06777 10.0323C7.28661 4.74683 14.8179 4.74838 15.036 10.0323C15.036 12.2292 13.2487 14.0164 11.0519 14.0164ZM11.0519 7.92305C9.88884 7.92305 8.94264 8.86925 8.94264 10.0323C9.05851 12.8305 13.0457 12.8296 13.1611 10.0323C13.1611 8.86925 12.2149 7.92305 11.0519 7.92305Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.c54be090cf8a91c0fec7cb75cfa8e4eb.svg";
export { ForwardRef as ReactComponent };